
import React, { useEffect, useState } from 'react'
import { Nav, NavDropdown, Container, Form, FormControl, Button, Collapse } from 'react-bootstrap';
import Navbar from 'react-bootstrap/Navbar'
import { FaAddressCard, FaAdversal, FaArchway, FaBookReader, FaCcDiscover } from 'react-icons/fa';


function Menu(props) {
    const [open, setOpen] = useState(false);



    return (<>

        <div className='row mt-5'>
            <div className='menuLink'
                onClick={() => setOpen(!open)}>
                <b><FaArchway className='mb-1 mr-2'></FaArchway>  Stato civile</b>
            </div>

            {/* <Collapse in={open}>
                <div id="example-collapse-text">
                    Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus
                    terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer
                    labore wes anderson cred nesciunt sapiente ea proident.
                </div>
            </Collapse> */}

        </div>
{/* 

        <div className='row mt-3'>
            <div className='menuLink'
                onClick={() => setOpen(!open)}>
               <FaAddressCard className='mb-1  mr-2'></FaAddressCard> <b className='ml-4'>Carta d'identità</b>
            </div>

            <Collapse in={open}>
                <div id="example-collapse-text">
                    Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus
                    terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer
                    labore wes anderson cred nesciunt sapiente ea proident.
                </div>
            </Collapse>

        </div>


        <div className='row mt-3'>
            <div className='menuLink'
                onClick={() => setOpen(!open)}>
                <b><FaArchway className='mb-1 '></FaArchway>  Stato civile</b>
            </div>

            <Collapse in={open}>
                <div id="example-collapse-text">
                    Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus
                    terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer
                    labore wes anderson cred nesciunt sapiente ea proident.
                </div>
            </Collapse>

        </div> */}




    </>
    );
}

export default Menu;